import { useEffect, useRef } from 'react';

import { useSelector } from 'react-redux';

import { formatDateNonlocalised } from '../../../../bootstrap/localisation';
import { updateHotelAdvertDates } from '../../../../services/strevdaRuntime/library';
import {
  getSelectedInboundDate,
  getSelectedOutboundDate,
} from '../../selectors';

export const useUpdateStrevdaDates = (enabled: boolean) => {
  const outboundDate = useSelector(getSelectedOutboundDate);
  const inboundDate = useSelector(getSelectedInboundDate);
  const initializedRef = useRef(false);

  useEffect(() => {
    if (!enabled) return;

    // Initial dates are already present in the server-rendered Strevda props.
    if (!initializedRef.current) {
      initializedRef.current = true;
      return;
    }

    if (!outboundDate) return;

    updateHotelAdvertDates(
      formatDateNonlocalised(outboundDate),
      inboundDate ? formatDateNonlocalised(inboundDate) : null,
    );
  }, [enabled, inboundDate, outboundDate]);
};
